module.exports = __webpack_public_path__ + "img/remove-category.1c2f0995.svg";